
import { Config } from '@/api/http';
import OpenEngineerApi from '@/api/OpenEngineerApi';
import { message } from 'ant-design-vue';
import { computed, defineComponent, reactive, ref, toRef, toRefs, watch } from 'vue';

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  setup (props, ctx) {
    const showModal = computed({
      get () {
        return props.visible
      },
      set (value) {
        ctx.emit('update:visible', value)
      }
    })
    const state = reactive({
      indeterminate: false,
      checkAll: false,
      checkedList: []
    });
    const options = ref<Array<string>>([])
    const values = ref<Array<number>>([])

    const onCheckAllChange = (e: any) => {
      Object.assign(state, {
        checkedList: e.target.checked ? values.value : [],
        indeterminate: false
      })
    }

    watch(
      () => state.checkedList,
      val => {
        state.indeterminate = !!val.length && val.length < options.value.length
        state.checkAll = val.length === options.value.length
      }
    )

    function loadChecks () {
      OpenEngineerApi.getChecks().then(res => {
        options.value = res
        values.value = Array.apply(null, Array(res.length)).map((item, i) => i)
      })
    }

    watch(
      showModal,
      (n) => {
        if (n) {
          loadChecks()
        }
      }
    )

    function handleOk () {
      // ctx.emit('OK', 111)
      if (state.checkedList.length < 5) {
        message.error('至少选择5项')
        return
      }
      const domainUrl = "/export_engineer?values=" + state.checkedList + '&searchKey=' + props.searchKey + '&_token=' + Config._token;
      window.open(domainUrl);
      ctx.emit('update:visible', false)
    }

    return {
      showModal,
      ...toRefs(state),
      options,
      onCheckAllChange,
      handleOk
    }
  }
})
